import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=3cab0e5d"
import script from "./exam.vue?vue&type=script&lang=ts"
export * from "./exam.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports